import { AxiosInstance } from "axios";

/**
 * Interceptor de autenticação para adicionar token JWT automaticamente
 * 
 * Funcionalidades:
 * - Adiciona token JWT do localStorage em todas as requisições
 * - Remove token em caso de erro 401
 * - Redireciona para login em caso de token inválido
 */
export const setupAuthInterceptor = (client: AxiosInstance): void => {
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      console.error("[Auth Interceptor] Request error:", error);
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        // Token inválido ou expirado
        localStorage.removeItem("access_token");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
}; 